import { z } from "zod";

/**
 * #1674: what a dbt repository save answers beside the saved binding when the save is fine and
 * still worth a second look (the #1292 `SELECTS_NO_MODELS` pattern). The sentence is the server's;
 * the client shows it beside Save and never composes one.
 *
 * `REF_NOT_FOUND`: the repository, read with the saved token, advertises no branch or tag of the
 * saved name, so every dbt run would fail at the checkout. A warning, not a refusal: the branch
 * may be pushed after the save, and a probe that cannot run says nothing.
 */
export const dbtSourceWarningSchema = z.object({
  code: z.literal("REF_NOT_FOUND"),
  message: z.string(),
});
export type DbtSourceWarning = z.infer<typeof dbtSourceWarningSchema>;

export function refNotFoundWarning(ref: string): DbtSourceWarning {
  return {
    code: "REF_NOT_FOUND",
    message: `The dbt branch ${ref} was not found in the repository. The dbt repository is saved, and dbt runs fail until the branch exists.`,
  };
}
